
export const ColumnWidth = {
  Number: 2,
  FirstName: 6,
  LastName: 6,
  Gender: 5.5,
  Age: 5.5,
  Birthday: 7,
  Nationality: 7,
  Expand: 5,
  Cabin: 7,
};



// WEBPACK FOOTER //
// ./src/domain/columnWidth.js